var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"backdrop"}),_c('Fold1'),_c('Fold2'),_c('Fold3'),_c('Fold4'),_c('Fold5'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }